import { Box } from '@mui/material';
import { ImageAsset as TImageAsset } from '@/types/generated';
import { getSideImageBoxStyles } from './SingleMessage.styles';
import ImageAsset, { IImage } from '../ImageAsset/ImageAsset';
import { Maybe } from '@shared-components/types';
export const SideImage = ({
  imageAsset,
  side = 'left',
  isSmallScreen,
  isHeaderAboveSideImages
}: {
  imageAsset?: TImageAsset;
  side?: 'left' | 'right';
  isSmallScreen?: Maybe<boolean>;
  isHeaderAboveSideImages?: Maybe<boolean>;
}) => {
  const widthHeightSize = 'auto';
  const imageSx = {
    objectFit: 'none',
    height: widthHeightSize,
    width: widthHeightSize,
    minWidth: '0',
    minHeight: '0',
    maxWidth: '100%'
  };
  return <Box sx={getSideImageBoxStyles(side, !!isHeaderAboveSideImages)} data-sentry-element="Box" data-sentry-component="SideImage" data-sentry-source-file="SideImage.tsx">
			<ImageAsset desktopImage={imageAsset?.desktopImage as IImage} mobileImage={imageAsset?.mobileImage as IImage} isBackgroundImage={false} imageSx={imageSx} dataTestId={`single_message_sideimage-${side}${isSmallScreen ? '-mobile' : ''}`} data-sentry-element="ImageAsset" data-sentry-source-file="SideImage.tsx" />
		</Box>;
};